import { AppBar, styled } from "@mui/material";

export const TopNavigationWrapper = styled(AppBar)(({ theme }) => {
    return {
        position: "static",
        paddingRight: "0 !important",
        backgroundColor: "#FFFFFF",
        "& .MuiToolbar-root": {
            minHeight: "6.5rem",
            backgroundColor: "inherit",
        },
        [theme.breakpoints.up("tablet")]: {
            width: "auto",
            position: "fixed",
            left: "var(--side-nav-width)",
        }
    }
})